import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';
import '../UnitI/style.css';  // Make sure to import your styles

const FlowI = () => {
  const videoNode = useRef(null); // Reference to the video element

  useEffect(() => {
    const video = videoNode.current;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource('http://203.101.178.101:108/video/stream.m3u8');
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error('HLS.js error:', data);
      });

      // Cleanup HLS.js instance
      return () => {
        hls.destroy();
      };
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // Fallback for Safari which supports native HLS
      video.src = 'http://203.101.178.101:108/video/stream.m3u8';
    }
  }, []);

  return (
    <div className="video-wrapper">
      <video ref={videoNode} controls autoPlay muted>
        Your browser does not support the video tag.
      </video>
      <div className="live-button">LIVE</div>
    </div>
  );
};

export default FlowI;
